module.exports = __webpack_public_path__ + "img/cogganj.46a47f05.jpg";